import React, { useState, useEffect } from "react";
import {
  Button,
  Tooltip,
  Card,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate, useParams } from "react-router-dom";
import BasicBreadcrumbs from "../../components/GeneralComponents/BreadCrumbs";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomModal from "../../components/CustomModel";
import FormInput from "../../components/GeneralComponents/FormInput";
import { formatNumber, show_proper_words } from "../../utils/constant";
import moment from "moment";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";
import {
  _List_Transaction_Detail,
  _Update_Status_Transaction,
} from "../../DAL/Listing/TransactionList";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";
import { picBaseUrl } from "../../config/config";
import CustomSelect from "../../components/GeneralComponents/CustomSelect";

const PaymentRequestDetail = ({ dashbaord }) => {
  const { setnavbarTitle, socket } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [rowData, setRowData] = useState({});
  const [modelState, setOpenModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [isCancel, setIsCancel] = useState(false);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({
    address: "",
    amount: "",
  });
  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    // { value: "stripe_fee", label: "Stripe fee" },
    { value: "wire_fee", label: "Wire fee" },
    { value: "wise_fee", label: "Wise fee" },
    { value: "crypto_fee", label: "Crypto fee" },
  ];

  /**
   * handleChange - Handles the selection of processor fee type.
   *
   * Validates the selected option based on the deposit method:
   * 1. For `domestic_wire` and `international_wire`, only "wire_fee" is allowed.
   * 2. For `crypto`, only "crypto_fee" is allowed.
   * If the validation fails, a warning message is shown using `enqueueSnackbar` and prevents further action.
   *
   * @param {object} event - The event object representing the change in selection.
   */
  const handleChange = (event) => {
    const selected = event.target.value;

    if (
      (rowData.deposit_method === "domestic_wire" ||
        rowData.deposit_method === "international_wire") &&
      selected !== "wire_fee"
    ) {
      enqueueSnackbar(
        "Please select the Processor fee type that matches the deposit method.",
        { variant: "warning" }
      );
      return; // Prevent selection
    }

    if (rowData.deposit_method === "crypto" && selected !== "crypto_fee") {
      enqueueSnackbar(
        "Please select the Processor fee type that matches the deposit method.",
        { variant: "warning" }
      );
      return; // Prevent selection
    }
    if (rowData.deposit_method === "wise_transfer" && selected !== "wise_fee") {
      enqueueSnackbar(
        "Please select the Processor fee type that matches the deposit method.",
        { variant: "warning" }
      );
      return; // Prevent selection
    }

    // If all validations pass
    setSelectedOption(selected);
  };

  /**
   * handleCloseModel - Resets the modal state and form data when the modal is closed.
   *
   * This function clears the state variables used for modal visibility, form data, and user selection.
   * It also resets any flags such as `isCancel` and `checked`.
   */
  const handleCloseModel = () => {
    setEmployee(null);
    setOpenModal(false);
    setData({
      address: "",
      amount: "",
    });
    setSelectedOption("");
    setIsCancel(false);
    setChecked(false);
  };

  const BreadCrumbsList = [];
  if (!dashbaord) {
    BreadCrumbsList.push(
      {
        title: "Deposit Request",
        navigation: "/deposit-request",
        active: false,
      },
      {
        title: `Deposit Request Detail`,
        navigation: "",
        status: "Active",
      }
    );
  } else {
    BreadCrumbsList.push(
      {
        title: "Dashboard",
        navigation: "/dashboard",
        active: false,
      },
      {
        title: `Deposit Request Detail`,
        navigation: "",
        status: "Active",
      }
    );
  }

  // Fetch and format employee details based on the search query.
  // Makes an API call, formats the results, and updates the state.
  // Prepare API request data with 'employee' type and the search term.
  // Fetch employee details from the API with the prepared form data.
  // On success, format the employee data (ID, name, email) and update state.
  // On failure, clear the employee list and display an error notification.
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value || "",
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    }
  };

  // Prevent default form submission and validate the amount and fee constraints.
  // Prepare data for updating transaction status, including the fee if applicable.
  // Handle the API response, display notifications, and navigate based on success or failure.
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Number(Data.amount) < 0) {
      enqueueSnackbar("Amount cannot be negative number ", {
        variant: "error",
      });
      return;
    }
    if (parseInt(Data?.amount) >= rowData?.total_amount) {
      enqueueSnackbar("Processor fee must be less than the total amount", {
        variant: "error",
      });
      return;
    }

    const data = {
      employee_id: employee.id || "",
      status: isCancel ? "failed" : "succeeded",
      message: Data?.address || "",
      processed_fee_type: selectedOption,
      processed_fee: Number(Data?.amount),
    };
    setIsLoading(true);

    if (isCancel) {
      delete data.processed_fee;
      delete data.processed_fee_type;
    }
    const response = await _Update_Status_Transaction(params.id, data);
    if (response.code === 200) {
      socket.emit("wallet_deposit_event", {
        notification: response.notification,
      });
      enqueueSnackbar(response.message, {
        variant: "success",
      });
      dashbaord ? navigate(`/dashboard`) : navigate(`/deposit-request`);
      setOpenModal(false);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * getPaymentDetails - Fetches transaction details based on the provided ID and updates the component state.
   *
   * This function sends a request to retrieve transaction details and stores the response in the component's state.
   * If the request is successful, the transaction data is saved, otherwise, an error message is displayed.
   */
  const getPaymentDetails = async () => {
    setLoading(true);
    const response = await _List_Transaction_Detail(params.id);
    if (response.code === 200) {
      setRowData(response?.transaction);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * useEffect - Initializes the page title and fetches payment details and user information when the component mounts or when `params.id` changes.
   *
   * This effect sets the navbar title to "Deposit Request Detail", retrieves payment details based on the transaction ID,
   * and fetches user details associated with the transaction.
   */
  useEffect(() => {
    setnavbarTitle("Deposit Request Detail");
    getPaymentDetails();
    handleGetDetailUser();
  }, [params.id]);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 mb-3">
          <BasicBreadcrumbs items={BreadCrumbsList} />
        </div>
        <div className="col-12">
          <Card
            style={{
              border: "2px solid #bebebe21",
            }}
          >
            <div className="row p-3">
              <div
                className={`col-12 ${
                  rowData.deposit_method !== "credit_card"
                    ? "col-md-8"
                    : "col-md-12"
                }`}
              >
                {/* <div className="mb-3">
                  <span>{rowData?.business_entity || "_ _"}</span>
                </div> */}
                <div className="mb-3 d-flex align-items-center svg-color date-color">
                  <Icon icon="uiw:date" />
                  <span className="ms-2">
                    {moment(rowData?.date).format("DD MMM YY hh:mm A") || "_ _"}
                  </span>
                </div>
                <div className="row detail_page_list">
                  <div className="col-8 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Name:
                  </div>
                  <div className="col-4 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {rowData?.user_info
                      ? show_proper_words(
                          rowData?.user_info?.first_name +
                            " " +
                            rowData?.user_info?.last_name
                        )
                      : "_ _"}
                  </div>
                  <div className="col-8 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Email:
                  </div>
                  <div className="col-4 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {rowData?.user_info?.email || "_ _"}
                  </div>
                  <div className="col-8 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Transfer For:
                  </div>
                  <div className="col-4 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {show_proper_words(rowData.transaction_for) || "_ _"}
                  </div>
                  <div className="col-8 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Payment Method:
                  </div>
                  <div className="col-4 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    {rowData.deposit_method === "crypto"
                      ? "Crypto Transfer"
                      : rowData.deposit_method === "credit_card"
                      ? "Credit Card Transfer"
                      : show_proper_words(rowData.deposit_method) || "_ _"}
                  </div>
                  <div className="col-8 col-md-6 col-lg-3 mt-3 mt-lg-2">
                    Total Amount:
                  </div>
                  <div className="col-4 col-md-6 col-lg-3  mt-3 mt-lg-2 text-muted">
                    ${rowData?.total_amount || "_ _"}
                  </div>
                </div>
              </div>
              {rowData.deposit_method !== "credit_card" && (
                <div className="col-12 col-md-4">
                  <div className="mt-3">
                    <img
                      src={picBaseUrl + rowData?.attachment_url}
                      className="img-fluid"
                    />
                  </div>
                </div>
              )}
              <div className="col-12 text-end mt-3">
                {rowData.status !== "failed" &&
                  rowData.deposit_method !== "credit_card" && (
                    <Button
                      variant="contained"
                      className="mb-2 mb-md-0"
                      onClick={() => {
                        setIsCancel(true);
                        setOpenModal(true);
                      }}
                    >
                      Reject Payment
                    </Button>
                  )}
                {rowData.deposit_method !== "credit_card" && (
                  <Button
                    variant="contained"
                    className="ms-3"
                    type="submit"
                    onClick={() => {
                      setIsCancel(false);
                      setOpenModal(true);
                    }}
                  >
                    Approve Payment
                  </Button>
                )}
              </div>
            </div>
          </Card>
        </div>
      </div>
      <CustomModal
        crossButton={true}
        CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <form onSubmit={handleSubmit}>
            {isCancel ? (
              <>
                <div className="my-3">
                  <SingleSelectAutocomplete
                    inputLabel={isCancel ? "Rejection by" : "Approve By"}
                    selectedOption={employee}
                    setSelectedOption={setEmployee}
                    optionsList={employeeArray}
                    required={true}
                    name="name"
                    size="medium"
                  />
                </div>
                <div className="my-3">
                  <FormInput
                    label="Rejection Message"
                    name="address"
                    type="text"
                    multline={true}
                    value={Data.address}
                    onChange={(e) =>
                      setData({ ...Data, address: e.target.value })
                    }
                  />
                </div>
                <div className="my-3  text-end">
                  <Tooltip
                    title={
                      !Data.address
                        ? "Please enter a rejection message"
                        : !employee
                        ? "Please select all required fields"
                        : ""
                    }
                  >
                    <span>
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={!Data.address || !employee || isLoading}
                      >
                        {isLoading ? "Please Wait..." : "Reject Payment"}
                      </Button>
                    </span>
                  </Tooltip>
                </div>
              </>
            ) : (
              <div className="">
                <h5>Details</h5>
                <div className="card_modal">
                  <div className="d-flex justify-content-between align-center mt-2">
                    <p className="mb-0">Amount To Send</p>
                    <p className="mb-0">Name</p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-1">
                    <p className="mb-0 text-muted">
                      ${formatNumber(rowData?.total_amount) || "_ _"}
                    </p>
                    <p className="mb-0 text-muted">
                      {rowData?.user_info
                        ? show_proper_words(
                            rowData?.user_info?.first_name +
                              " " +
                              rowData?.user_info?.last_name
                          )
                        : "_ _"}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-2">
                    <p className="mb-0">Email</p>
                    <p className="mb-0">Deposit Method</p>
                  </div>
                  <div className="d-flex justify-content-between align-center mt-1">
                    <p className="mb-0 text-muted">
                      {rowData?.user_info?.email || "_ _"}
                    </p>
                    <p className="mb-0 text-muted">
                      {rowData.deposit_method === "crypto"
                        ? "Crypto Transfer"
                        : rowData.deposit_method === "credit_card"
                        ? "Credit Card Transfer"
                        : show_proper_words(rowData.deposit_method) || "_ _"}
                    </p>
                  </div>
                  {rowData.deposit_method !== "credit_card" && (
                    <div className="mt-3">
                      <img
                        src={picBaseUrl + rowData?.attachment_url}
                        className="img-fluid"
                      />
                    </div>
                  )}
                  {!isCancel && (
                    <div className="d-flex flex-wrap justify-content-lg-between">
                      <div className="mt-3 col-6 text-start">
                        <CustomSelect
                          label="Select Processor Fees"
                          value={selectedOption}
                          onChange={handleChange}
                          options={options}
                          name="processor_fees"
                          helperText="Please select Processor Fees"
                        />
                      </div>
                      <div className="mt-3 col-6 text-end">
                        <TextField
                          label="Enter Processor Fee $"
                          name="amount"
                          type="number"
                          required
                          inputProps={{
                            min: 0,
                          }}
                          value={Data.amount}
                          onChange={(e) =>
                            setData({ ...Data, amount: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div className="my-3">
                    <SingleSelectAutocomplete
                      inputLabel={isCancel ? "Rejection by" : "Approve By"}
                      selectedOption={employee}
                      setSelectedOption={setEmployee}
                      optionsList={employeeArray}
                      required={true}
                      name="name"
                      size="medium"
                    />
                  </div>
                  <div className="my-3">
                    <FormInput
                      label="Message"
                      name="address"
                      type="text"
                      multline={true}
                      value={Data.address}
                      onChange={(e) =>
                        setData({ ...Data, address: e.target.value })
                      }
                    />
                  </div>
                  <div className="mt-2 text-start">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={(e) => setChecked(e.target.checked)}
                        />
                      }
                      label={
                        isCancel
                          ? "Are you sure you want to Reject this payment?"
                          : "Are you sure you want to Approve this payment?"
                      }
                    />
                  </div>
                  <div className="mt-2 text-end">
                    <Tooltip
                      title={
                        !checked
                          ? "Please check the box to enable"
                          : !employee
                          ? "Please select all required fields"
                          : ""
                      }
                      placement="top"
                    >
                      <span>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={!checked || !employee || isLoading}
                        >
                          {isLoading
                            ? "Please Wait..."
                            : isCancel
                            ? "Reject"
                            : "Approve"}
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}
          </form>
        }
      />
    </div>
  );
};

export default PaymentRequestDetail;
